import "./styles.scoped.css";
export default {
    "selectable-item": "awsui_selectable-item_15o6u_1g6vu_93",
    "pad-bottom": "awsui_pad-bottom_15o6u_1g6vu_113",
    "has-background": "awsui_has-background_15o6u_1g6vu_122",
    "highlighted": "awsui_highlighted_15o6u_1g6vu_125",
    "selected": "awsui_selected_15o6u_1g6vu_125",
    "disabled": "awsui_disabled_15o6u_1g6vu_139",
    "next-item-selected": "awsui_next-item-selected_15o6u_1g6vu_147",
    "is-keyboard": "awsui_is-keyboard_15o6u_1g6vu_155",
    "parent": "awsui_parent_15o6u_1g6vu_159",
    "interactiveGroups": "awsui_interactiveGroups_15o6u_1g6vu_163",
    "child": "awsui_child_15o6u_1g6vu_175",
    "virtual": "awsui_virtual_15o6u_1g6vu_190",
    "measure-strut": "awsui_measure-strut_15o6u_1g6vu_201",
    "measure-strut-first": "awsui_measure-strut-first_15o6u_1g6vu_210",
    "screenreader-content": "awsui_screenreader-content_15o6u_1g6vu_214",
    "option-content": "awsui_option-content_15o6u_1g6vu_220"
};
